import { useLazyQuery, useMutation } from '@apollo/client/react';
import { useEffect } from 'react';

import {
  GetAppointmentUnreadOrganizationNotificationDocument,
  MarkOrganizationNotificationDocument,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useMarkNotification = (appointmentId?: string | null) => {
  const [markNotification] = useMutation(MarkOrganizationNotificationDocument);
  const [getNotifications, { data }] = useLazyQuery(
    GetAppointmentUnreadOrganizationNotificationDocument,
    {
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    if (appointmentId) {
      getNotifications({
        variables: {
          appointmentId,
        },
      });
    }
  }, [appointmentId, getNotifications]);

  useEffect(() => {
    if (!data) return;

    const notifications = getNode(data, 'Appointment')?.unreadOrganizationNotifications || [];
    for (const notification of notifications) {
      markNotification({
        variables: {
          input: {
            organizationNotificationId: notification.id,
          },
        },
      });
    }
  }, [data, markNotification]);
};
